import { render, staticRenderFns } from "./getVis.vue?vue&type=template&id=88505496&scoped=true&"
import script from "./getVis.vue?vue&type=script&lang=js&"
export * from "./getVis.vue?vue&type=script&lang=js&"
import style0 from "./getVis.vue?vue&type=style&index=0&id=88505496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88505496",
  null
  
)

export default component.exports